import { useState } from 'react';

const useImageViewModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [modalTitle, setModalTitle] = useState('Visualizar Imagem');

  const showImageModal = (data, title = 'Visualizar Imagem') => {
    setImageData(data);
    setModalTitle(title);
    setShowModal(true);
  };

  const hideImageModal = () => {
    setShowModal(false);
    // Pequeno delay antes de limpar os dados para evitar flash
    setTimeout(() => {
      setImageData(null);
      setModalTitle('Visualizar Imagem');
    }, 200);
  };

  const modalProps = {
    show: showModal,
    onHide: hideImageModal,
    imageData,
    title: modalTitle,
  };

  return {
    showImageModal,
    hideImageModal,
    modalProps,
    isModalOpen: showModal,
  };
};

export default useImageViewModal;
